module.exports = __webpack_public_path__ + "static/media/login-bg.33c469f0.jpg";